export default __webpack_public_path__ + "static/media/logstash-no-broker.babb08c4.gif";